import request from '@/utils/request'

export function getProjectPage(params) {
  return request({
    url: '/api/project/page',
    method: 'get',
    params
  })
}

export function getProjectDetail(id) {
  return request({
    url: `/api/project/${id}`,
    method: 'get'
  })
}

export function createProjectFromContract(contractId, data) {
  return request({
    url: `/api/project/from-contract/${contractId}`,
    method: 'post',
    data
  })
}

export function createProjectFromLead(leadId, data) {
  return request({
    url: `/api/project/from-lead/${leadId}`,
    method: 'post',
    data
  })
}

export function updateProject(id, data) {
  return request({
    url: `/api/project/${id}`,
    method: 'put',
    data
  })
}

export function recalcProject(id) {
  return request({
    url: `/api/project/${id}/recalculate`,
    method: 'post'
  })
}
